export default "__VITE_ASSET__lsFbl$ZM__"